import React from 'react';
import { Link } from 'react-router-dom';
import { getKeycloakLoginUrl, getDriverAppUrl } from '../auth';
import useBrand from '../branding/useBrand';
import '../pages/Page.css';

function CTASection({
  heading,
  subheading,
  showDriverLink = true,
  showContact = true,
}) {
  const brand = useBrand();
  const effectiveHeading = heading ?? brand.cta.heading;
  const effectiveSubheading = subheading ?? brand.cta.subheading;
  const handleLoginAsCPO = () => { window.location.href = getKeycloakLoginUrl(); };

  return (
    <section className="page-section cta-section">
      <div className="cta-panel">
        <div className="cta-copy">
          <span className="cta-eyebrow">{brand.cta.eyebrow}</span>
          {effectiveHeading && <h2 className="cta-title">{effectiveHeading}</h2>}
          {effectiveSubheading && <p className="cta-subheading">{effectiveSubheading}</p>}
        </div>

        <div className="cta-actions">
          <button type="button" className="btn btn-primary cta-primary" onClick={handleLoginAsCPO}>
            {brand.cta.loginAsCpo}
          </button>
          {showContact && (
            <Link to="/contact" className="btn btn-outline-light cta-secondary">
              {brand.cta.requestDemo}
            </Link>
          )}
          {showDriverLink && (
            <a href={getDriverAppUrl()} className="cta-driver-link">
              {brand.cta.driverLink} &rarr;
            </a>
          )}
        </div>
      </div>
    </section>
  );
}

export default CTASection;
